module.exports = {
	"properties": {
		"beforeRequest": {
			"$ref": "#cacheEntry"
		},
		"afterRequest": {
			"$ref": "#cacheEntry"
		},
		"comment": {
			"type": "string"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/har-validator/lib/schemas/cache.json
// module id = 138
// module chunks = 0 1